import { useCallback, useEffect, useRef, useState } from 'react';

export const useVarianceDrawerReviewFields = ({
  row,
  review,
  saveReview,
  onReviewChange,
} = {}) => {
  const canPersistReview = Boolean(row?.id && !row?.sourceContext);
  const [category, setCategory] = useState(review?.category || null);
  const [remediation, setRemediation] = useState(review?.remediation || null);
  const categorySaveTimerRef = useRef(null);
  const remediationSaveTimerRef = useRef(null);
  const lastSavedCategoryRef = useRef(review?.category || null);
  const lastSavedRemediationRef = useRef(review?.remediation || null);

  useEffect(() => {
    setCategory(review?.category || null);
    setRemediation(review?.remediation || null);
    lastSavedCategoryRef.current = review?.category || null;
    lastSavedRemediationRef.current = review?.remediation || null;
  }, [row?.bac, review?.category, review?.remediation]);

  useEffect(() => {
    if (!canPersistReview || (category || null) === (lastSavedCategoryRef.current || null)) return undefined;
    clearTimeout(categorySaveTimerRef.current);
    categorySaveTimerRef.current = setTimeout(() => {
      const next = saveReview(row, { category: category || null });
      lastSavedCategoryRef.current = category || null;
      onReviewChange(row.bac, next);
    }, 350);
    return () => clearTimeout(categorySaveTimerRef.current);
  }, [canPersistReview, category, row, saveReview, onReviewChange]);

  useEffect(() => {
    if (!canPersistReview || (remediation || null) === (lastSavedRemediationRef.current || null)) return undefined;
    clearTimeout(remediationSaveTimerRef.current);
    remediationSaveTimerRef.current = setTimeout(() => {
      const next = saveReview(row, { remediation: remediation || null });
      lastSavedRemediationRef.current = remediation || null;
      onReviewChange(row.bac, next);
    }, 350);
    return () => clearTimeout(remediationSaveTimerRef.current);
  }, [canPersistReview, remediation, row, saveReview, onReviewChange]);

  const handleMarkReviewed = useCallback(() => {
    if (!canPersistReview) return;
    const next = saveReview(row, { reviewed: !review?.reviewed, category, remediation });
    onReviewChange(row.bac, next);
  }, [canPersistReview, category, onReviewChange, remediation, review?.reviewed, row, saveReview]);

  return {
    category,
    handleMarkReviewed,
    remediation,
    setCategory,
    setRemediation,
  };
};
